// --- Shareholder Types List (for Shareholders) ---
export const SHAREHOLDER_TYPES = [
  'Founder',
  'Management',
  'Investor',
  'Advisor',
  'Employee',
  'Other'
];

// --- Entity Types for Shareholders ---
export const ENTITY_TYPES = [
  'Individual',
  'Company',
  'Trust',
  'Organisation'
];

// --- Director Types List (for Directors) ---
export const DIRECTOR_TYPES = [
  { id: 'is_director', label: 'Director' },
  { id: 'is_alternate_director', label: 'Alternate Director' },
  { id: 'is_company_secretary', label: 'Company Secretary' }
];

// --- Director Status Options ---
export const DIRECTOR_STATUS = [
  'Active',
  'Resigned'
];

// Share types to exclude from 'ex-Options' calculations
export const EXCLUDED_SHARE_TYPES = ['Convertible', 'Options'];
